window.Engineering = function(uid, cfg) {
const GREEN="#B9FF00", RED="#E7574E", TAU=Math.PI*2;
const cv=document.getElementById("eng-c"+uid), ctx=cv.getContext("2d");

const ui={
  speed:       cfg.speed       !==""?+cfg.speed       :0.12,
  flow:        cfg.flow        !==""?+cfg.flow        :1.1,
  twist:       cfg.twist       !==""?+cfg.twist       :2.2,
  amp:         cfg.amp         !==""?+cfg.amp         :0.42,
  size:        cfg.size        !==""?+cfg.size        :3.4,
  scatter:     cfg.scatter     !==""?+cfg.scatter     :0.08,
  voff:        cfg.voff        !==""?+cfg.voff        :2,
  n:           cfg.n           !==""?+cfg.n           :42,
  lineOpacity: cfg.lineOpacity !==""?+cfg.lineOpacity :1,
  mode:        cfg.mode        !==""? cfg.mode        :"trend",
  comp:        cfg.comp        !==""? cfg.comp        :"dna",
  playing:     cfg.pause==="true"?false:true
};

function lcgRandom(seed){
  let s=seed|0;
  return ()=>{ s=(Math.imul(1664525,s)+1013904223)|0; return (s>>>0)/0x100000000; };
}
function normalRandom(uniform){
  return ()=>{ let u,v; do{u=uniform();v=uniform();}while(!u);
    return Math.sqrt(-2*Math.log(u))*Math.cos(TAU*v); };
}
function fmtDate(d){ return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"); }
function fmtTime(d){ return String(d.getHours()).padStart(2,"0")+":"+String(d.getMinutes()).padStart(2,"0"); }
const baseDate=new Date(2024,2,28);
const baseClock=new Date(2024,2,28,9,41,0);
function offsetDay(d,n){ return new Date(d.getTime()+n*86400000); }
function offsetMin(d,n){ return new Date(d.getTime()+n*60000); }

let buf, rng, lastPrice, dataSeed, finLo=null, finHi=null;
function resetData(){
  dataSeed=Math.random()*1e6|0;
  finLo=finHi=null;
  buf=[[],[]]; lastPrice=[100,100];
  rng=[normalRandom(lcgRandom(dataSeed+11)),
       normalRandom(lcgRandom(dataSeed+907))];
}
const POOL=512;
function candleAt(s,idx){
  idx=((idx%POOL)+POOL)%POOL;
  const b=buf[s];
  while(b.length<=idx){
    const open=lastPrice[s], dir=rng[s]()>=0?1:-1;
    const body=(2.4+Math.abs(rng[s]())*3.4)*dir, close=open+body;
    let upW=Math.abs(rng[s]())*0.7+0.2, dnW=Math.abs(rng[s]())*0.7+0.2;
    if(Math.abs(rng[s]())>1.5){
      if(rng[s]()>=0) upW+=2.6+Math.abs(rng[s]())*3.6;
      else dnW+=2.6+Math.abs(rng[s]())*3.6;
    }
    const high=Math.max(open,close)+upW, low=Math.min(open,close)-dnW;
    b.push({open,close,high,low}); lastPrice[s]=close;
  }
  return b[idx];
}
resetData();

function hash(i){ const x=Math.sin(i*12.9898+78.233)*43758.5453; return x-Math.floor(x); }

let W=0, H=0, DPR=1;
const nFixed=cfg.n!=="", nBase=ui.n;
function resize(){
  DPR=Math.min(window.devicePixelRatio||1,2);
  W=cv.clientWidth; H=cv.clientHeight;
  cv.width=W*DPR; cv.height=H*DPR;
  ctx.setTransform(DPR,0,0,DPR,0,0);
  if(nFixed) ui.n=W<480?Math.max(8,nBase>>1):nBase;
  else ui.n=Math.max(16,Math.round(W/19));
}
window.addEventListener("resize", resize);

function colourFor(c,s){ return ui.mode==="strand"?(s===0?GREEN:RED):(c.close>=c.open?GREEN:RED); }
function smoothstep(a,b,x){ const t=Math.max(0,Math.min(1,(x-a)/(b-a))); return t*t*(3-2*t); }
function edgeAlpha(yp){ const b=0.05; return smoothstep(-b,b,yp)*smoothstep(1+b,1-b,yp); }
const lineStroke=(f,al)=>`rgba(226,236,255,${(0.1+f*0.42)*al})`;
function scatterOf(idx,s){
  const ang=hash(idx*7+s*131)*TAU, rad=hash(idx*7+3+s*131);
  const o=Math.min(W,H)*0.16*ui.scatter;
  return {dx:Math.cos(ang)*rad*o, dy:Math.sin(ang)*rad*o};
}
function mkCandle(s,idx,hx,hy,f,a){
  const c=candleAt(s,idx), o=scatterOf(idx,s);
  return {p:{s,idx,c,x:hx+o.dx,y:hy+o.dy,f,a:a==null?1:a}, range:c.high-c.low};
}
function polyLine(items,pts,base){
  for(let i=0;i<pts.length-1;i++){
    const a=pts[i], b=pts[i+1], f=(a.f+b.f)/2;
    items.push({t:"line",x1:a.x,y1:a.y,x2:b.x,y2:b.y,
      stroke:`rgba(226,236,255,${base*(0.4+0.6*f)})`,w:1.0,z:f});
  }
}
function pushRungs(items,A,B,base,stride){
  const n=Math.min(A.length,B.length);
  for(let i=0;i<n;i+=(stride||1)){
    const a=A[i], b=B[i], f=Math.min(a.f,b.f);
    items.push({t:"line",x1:a.x,y1:a.y,x2:b.x,y2:b.y,
      stroke:`rgba(200,214,255,${base*(0.4+0.6*f)})`,w:0.7,z:f});
  }
}
function backboneSeg(a,b){
  const f=(a.f+b.f)/2;
  return {t:"line",x1:a.x,y1:a.y,x2:b.x,y2:b.y,
    stroke:`rgba(226,236,255,${0.3*(0.3+0.7*f)})`,w:0.8+1.6*f,z:f};
}
function orthoPath(seed,y0,yMin,yMax){
  const xStart=W*0.06, xEnd=W*0.94;
  const pts=[{x:xStart,y:y0}]; let x=xStart, y=y0, horiz=true;
  for(let k=0;k<7;k++){
    const r=hash(seed*97+k*13+1);
    if(horiz) x=x+(xEnd-x)*(0.3+0.55*r);
    else y=yMin+(yMax-yMin)*r;
    pts.push({x,y}); horiz=!horiz;
  }
  if(x<xEnd-1) pts.push({x:xEnd,y});
  return pts;
}
function sampleRounded(wp,rr){
  const out=[{x:wp[0].x,y:wp[0].y}];
  for(let i=1;i<wp.length-1;i++){
    const p0=wp[i-1],p1=wp[i],p2=wp[i+1];
    const d1={x:Math.sign(p1.x-p0.x),y:Math.sign(p1.y-p0.y)};
    const d2={x:Math.sign(p2.x-p1.x),y:Math.sign(p2.y-p1.y)};
    const r=Math.min(rr,Math.hypot(p1.x-p0.x,p1.y-p0.y)/2,Math.hypot(p2.x-p1.x,p2.y-p1.y)/2);
    const a={x:p1.x-d1.x*r,y:p1.y-d1.y*r}, b={x:p1.x+d2.x*r,y:p1.y+d2.y*r};
    out.push(a);
    for(let t=1;t<=5;t++){ const u=t/5, w0=(1-u)*(1-u), w1=2*(1-u)*u, w2=u*u;
      out.push({x:w0*a.x+w1*p1.x+w2*b.x, y:w0*a.y+w1*p1.y+w2*b.y}); }
  }
  out.push({x:wp[wp.length-1].x,y:wp[wp.length-1].y});
  return out;
}
function alongPath(poly,cum,d){
  let i=1; while(i<cum.length-1 && cum[i]<d) i++;
  const t=(d-cum[i-1])/Math.max(1e-6,cum[i]-cum[i-1]);
  return {x:poly[i-1].x+(poly[i].x-poly[i-1].x)*t, y:poly[i-1].y+(poly[i].y-poly[i-1].y)*t};
}
function timeLabels(cand,every,cx){
  const out=[];
  for(let i=0;i<cand.length;i++){ const p=cand[i].p;
    if(p.f<0.5||i%every!==0) continue;
    const left=p.x<cx;
    out.push({text:fmtTime(offsetMin(baseClock,-p.idx*7)),x:p.x+(left?-11:11),y:p.y,
      align:left?"right":"left",fill:`rgba(159,178,214,${(p.f-0.4)*0.6})`,font:"9px ui-monospace,Menlo,monospace"});
  }
  return out;
}
function scaleK(cand,targetPx){
  const r=cand.map(c=>c.range).sort((a,b)=>a-b);
  const med=r.length?r[r.length>>1]:4;
  return (targetPx/med)*ui.size;
}

let phase=0, flow=0;

function buildDNA(){
  const n=ui.n, cx=W/2, amplitude=Math.min(W*ui.amp,260);
  const margin=70, usableH=H-margin*2, slot=usableH/(n-1);
  const totalTwist=ui.twist*TAU, base=Math.floor(flow), frac=flow-base;
  const offParam=ui.voff/(n-1);
  const pts=[[],[]], all=[], items=[];
  for(let s=0;s<2;s++){
    for(let v=-1;v<=n+1;v++){
      const idx=base+v; if(idx<0) continue;
      let yParam=(v-frac)/(n-1); if(s===1) yParam+=offParam;
      const a=edgeAlpha(yParam); if(a<=0) continue;
      const theta=yParam*totalTwist+phase+s*Math.PI;
      const z=Math.cos(theta), f=(z+1)/2;
      const hx=cx+Math.sin(theta)*amplitude, hy=margin+yParam*usableH;
      const o=scatterOf(idx,s), c=candleAt(s,idx);
      const p={s,idx,c,hx,hy,x:hx+o.dx*0.9,y:hy+o.dy*1.6,z,f,a,rot:0};
      pts[s].push(p); all.push({range:c.high-c.low});
    }
  }
  const k=scaleK(all,slot*0.5);
  for(let s=0;s<2;s++){
    const P=pts[s];
    for(let i=0;i<P.length-1;i++){
      const a=P[i], b=P[i+1]; if(b.idx-a.idx!==1) continue;
      const f=(a.f+b.f)/2, al=(a.a+b.a)/2;
      items.push({t:"line",x1:a.hx,y1:a.hy,x2:b.hx,y2:b.hy,stroke:lineStroke(f,al),w:0.7+f*0.9,z:(a.z+b.z)/2});
    }
  }
  const map1=new Map(pts[1].map(p=>[p.idx,p]));
  for(const a of pts[0]){
    const b=map1.get(a.idx); if(!b) continue;
    const f=(a.f+b.f)/2, al=Math.min(a.a,b.a);
    items.push({t:"line",x1:a.hx,y1:a.hy,x2:b.hx,y2:b.hy,
      stroke:`rgba(200,214,255,${(0.07+f*0.22)*al})`,w:0.7,z:(a.z+b.z)/2});
  }
  for(let s=0;s<2;s++) for(const p of pts[s]) items.push({t:"candle",p,z:p.z});
  items.sort((a,b)=>a.z-b.z);
  const labels=[];
  for(const p of pts[0]){ if(p.f<0.5||p.idx%5!==0) continue; const left=p.hx<cx;
    labels.push({text:fmtDate(offsetDay(baseDate,-p.idx)),x:p.hx+(left?-12:12),y:p.hy,
      align:left?"right":"left",fill:`rgba(159,178,214,${(p.f-0.45)*0.55*p.a})`,font:"10px ui-monospace,Menlo,monospace"}); }
  for(const p of pts[1]){ if(p.f<0.5||p.idx%6!==0) continue; const left=p.hx<cx;
    labels.push({text:p.c.close.toFixed(1),x:p.hx+(left?-12:12),y:p.hy,
      align:left?"right":"left",fill:`rgba(159,178,214,${(p.f-0.45)*0.42*p.a})`,font:"9px ui-monospace,Menlo,monospace"}); }
  return {k,items,labels};
}

function buildMotorway(){
  const cx=W/2, M=Math.round(ui.n), items=[], all=[];
  const horizon=H*0.13, yNear=H*0.99, PERSP=5.5, wNear=W*0.44;
  const scFar=1/(1+PERSP), roadPhase=flow*0.55;
  const pairs=[];
  for(let i=0;i<M;i++){
    let t=(i/M)-flow*0.16; t-=Math.floor(t);
    const sc=1/(1+t*PERSP), ea=edgeAlpha(t);
    const y=horizon+(yNear-horizon)*sc;
    const bend=W*0.17*Math.sin(t*2.6+roadPhase)*t*t;
    const laneHalf=wNear*(sc-scFar)/(1-scFar);
    const f=0.18+0.82*sc, scl=0.3+1.2*sc;
    const edge=s=>{ const x=cx+bend+(s===0?-1:1)*laneHalf;
      const cd=mkCandle(s,i,x,y,f,ea); cd.p.scl=scl; all.push(cd); return {x,y,f:f*ea}; };
    pairs.push({L:edge(0),R:edge(1),t});
  }
  const order=[...pairs].sort((a,b)=>b.t-a.t);
  for(let i=0;i<order.length-1;i++){ const a=order[i],b=order[i+1]; if(Math.abs(a.t-b.t)>0.4) continue;
    items.push(backboneSeg(a.L,b.L)); items.push(backboneSeg(a.R,b.R)); }
  for(const p of pairs){ const f=Math.min(p.L.f,p.R.f);
    items.push({t:"line",x1:p.L.x,y1:p.L.y,x2:p.R.x,y2:p.R.y,stroke:`rgba(200,214,255,${0.18*(0.3+0.7*f)})`,w:0.7,z:f}); }
  const k=scaleK(all,H*0.018);
  for(const c of all) items.push({t:"candle",p:c.p,z:c.p.f});
  items.sort((a,b)=>a.z-b.z);
  return {k,items,labels:[]};
}

function buildHealth(){
  const M=Math.round(ui.n*1.4), items=[], all=[];
  const left=W*0.05, right=W*0.95, span=right-left, cy=H/2, amp=H*0.14;
  const fo=flow*1.1, base=Math.floor(fo), frac=fo-base, STEP=0.16;
  const strands=[[],[]];
  for(let v=-1;v<=M;v++){
    const g=base+v, prog=(v-frac)/(M-1), a=edgeAlpha(prog); if(a<=0) continue;
    const x=left+prog*span, w=g*STEP;
    const baseY=cy+amp*0.45*Math.sin(w*0.3)+amp*0.2*Math.sin(w*0.85+1);
    const sep=amp*(1.15+0.5*Math.sin(w*0.2+0.5));
    const beat=amp*0.14*Math.sin(w*1.15);
    for(let s=0;s<2;s++){
      const y=baseY+(s?1:-1)*sep*0.5+beat, f=0.45+0.55*a;
      strands[s].push({x,y,f}); all.push(mkCandle(s,g,x,y,f,a));
    }
  }
  pushRungs(items,strands[0],strands[1],0.13,2);
  for(let s=0;s<2;s++) polyLine(items,strands[s],0.3);
  const k=scaleK(all,amp*0.4);
  for(const c of all) items.push({t:"candle",p:c.p,z:c.p.f});
  items.sort((a,b)=>a.z-b.z);
  return {k,items,labels:timeLabels(all,12,W/2)};
}

function buildCircuit(){
  const items=[], all=[], rr=Math.min(W,H)*0.05;
  const paths=[sampleRounded(orthoPath(11,H*0.36,H*0.30,H*0.46),rr),
               sampleRounded(orthoPath(57,H*0.62,H*0.54,H*0.70),rr)];
  for(let s=0;s<2;s++){
    const poly=paths[s], cum=[0];
    for(let i=1;i<poly.length;i++) cum.push(cum[i-1]+Math.hypot(poly[i].x-poly[i-1].x,poly[i].y-poly[i-1].y));
    const total=cum[cum.length-1], fade=total*0.045;
    for(let i=0;i<poly.length-1;i++)
      items.push({t:"line",x1:poly[i].x,y1:poly[i].y,x2:poly[i+1].x,y2:poly[i+1].y,stroke:"rgba(226,236,255,0.24)",w:1.1,z:0.4});
    const M=Math.round(ui.n*0.8), spacing=total/M, drift=(flow*spacing*1.4)%total;
    for(let i=0;i<M;i++){
      const d=(i*spacing+drift)%total, pos=alongPath(poly,cum,d);
      const a=smoothstep(0,fade,d)*smoothstep(total,total-fade,d);
      const f=Math.max(0.12,(0.4+0.6*a)*(0.6+0.4*Math.sin(d/total*TAU*3-flow*3)));
      all.push(mkCandle(s,i+s*131,pos.x,pos.y,f,a));
    }
  }
  const k=scaleK(all,Math.min(W,H)*0.028);
  for(const c of all) items.push({t:"candle",p:c.p,z:c.p.f});
  items.sort((a,b)=>a.z-b.z);
  return {k,items,labels:timeLabels(all,7,W/2)};
}

function buildCoaster(){
  const M=Math.round(ui.n*1.4), items=[], all=[];
  const left=W*0.05, right=W*0.95, span=right-left, floorY=H*0.75, amp=H*0.5;
  const fo=flow*1.0, base=Math.floor(fo), frac=fo-base;
  function hill(u){ const cyc=Math.floor(u), q=u-cyc, peak=0.4+0.6*hash(cyc*53+7);
    let h; if(q<0.6){ const a=q/0.6; h=a*a*(3-2*a); }
    else { const a=(q-0.6)/0.4; h=1-a*a*(3-2*a); }
    return Math.max(0,h)*peak; }
  const offB=((ui.twist-1.5)/7.5)*0.5;
  const ratio=Math.max(0,Math.min(1,(ui.voff+14)/28));
  const ampS=[amp, amp*(0.08+0.92*ratio)];
  const strands=[[],[]];
  for(let v=-1;v<=M;v++){
    const g=base+v, prog=(v-frac)/(M-1), a=edgeAlpha(prog); if(a<=0) continue;
    const x=left+(1-prog)*span, u=(x-left)/span*3.0+flow*0.18;
    const hs=[hill(u),hill(u+offB)];
    for(let s=0;s<2;s++){
      const y=floorY-hs[s]*ampS[s], f=0.45+0.55*a;
      strands[s].push({x,y,f}); all.push(mkCandle(s,g,x,y,f,a));
    }
  }
  pushRungs(items,strands[0],strands[1],0.12,2);
  for(let s=0;s<2;s++) polyLine(items,strands[s],0.3);
  const k=scaleK(all,H*0.018);
  for(const c of all) items.push({t:"candle",p:c.p,z:c.p.f});
  items.sort((a,b)=>a.z-b.z);
  return {k,items,labels:timeLabels(all,12,W/2)};
}

function buildFinancial(){
  const M=Math.round(ui.n*1.4), items=[], all=[];
  const left=W*0.04, right=W*0.96, span=right-left, top=H*0.1, bot=H*0.94;
  const fo=flow*1.0, base=Math.floor(fo), frac=fo-base, sd=(dataSeed%1000)*0.001;
  const STEP=0.16, PMAX=2.0, yOf=pr=>bot-(pr/PMAX)*(bot-top);
  const dip=w=>{ const win=Math.floor(w/3.2), d=hash(win*91+5);
    if(d<0.5) return 0; const l=w-win*3.2-1.6;
    return -(0.3+0.6*d)*Math.exp(-(l*l)/(2*0.9*0.9)); };
  const trend=w=>1.0+0.5*Math.sin(w*0.22+sd)+0.3*Math.sin(w*0.45+0.6)+0.34*Math.sin(w*0.075)+dip(w);
  const price=g=>Math.max(0.1,Math.min(1.95,
    trend(g*STEP)+0.05*(hash(g*5+1)*2-1)+0.03*(hash(g*5+3)*2-1)));
  for(let v=-1;v<=M;v++){
    const g=base+v, prog=(v-frac)/(M-1), a=edgeAlpha(prog); if(a<=0) continue;
    const x=left+prog*span;
    const open=price(g-1), close=price(g);
    let upW=0.05+0.1*hash(g*3+1), dnW=0.05+0.1*hash(g*3+2);
    if(hash(g*3+7)>0.86){ if(hash(g*3+9)>0.5) upW+=0.1+0.22*hash(g*3+11); else dnW+=0.1+0.22*hash(g*3+11); }
    const hi=Math.max(open,close)+upW, lo=Math.min(open,close)-dnW, f=0.5+0.5*a;
    all.push({p:{s:0,idx:g,c:{open,close,high:hi,low:lo},x,y:0,f,a,
      ohlcY:{h:yOf(hi),l:yOf(lo),o:yOf(open),c:yOf(close)}}, range:hi-lo});
  }
  for(const c of all) items.push({t:"candle",p:c.p,z:0.6});
  return {k:1,items,labels:timeLabels(all,10,W/2)};
}

function buildCake(){
  const M=Math.round(ui.n), items=[], all=[];
  const cx=W/2, cy=H/2, R=Math.min(W,H)*0.4;
  const gap=H*0.02+ui.voff*H*0.013;
  const spin=phase;
  const slope=ui.twist*0.05;
  const tiers=[{rx:R,      ry:R*0.34, yc:cy+gap*0.5, m:M,                 s:0, tilt:-slope},
               {rx:R*0.64, ry:R*0.22, yc:cy-gap*0.5, m:Math.round(M*0.7), s:1, tilt:+slope}];
  const pt=(T,th)=>({x:cx+T.rx*Math.cos(th),
                     y:T.yc+T.ry*Math.sin(th)+T.tilt*T.rx*Math.cos(th),
                     f:0.4+0.6*(Math.sin(th)+1)/2});
  for(const T of tiers){
    const loop=[];
    for(let i=0;i<T.m;i++){
      const q=pt(T,spin+i/T.m*TAU);
      loop.push(q); all.push(mkCandle(T.s,i+T.s*131,q.x,q.y,q.f,1));
    }
    for(let i=0;i<loop.length;i++){
      const a=loop[i], b=loop[(i+1)%loop.length], f=(a.f+b.f)/2;
      items.push({t:"line",x1:a.x,y1:a.y,x2:b.x,y2:b.y,stroke:`rgba(226,236,255,${0.3*(0.35+0.65*f)})`,w:0.8+0.8*f,z:f});
    }
  }
  const [TL,TS]=tiers;
  for(let i=0;i<TL.m;i++){
    const th=spin+i/TL.m*TAU, a=pt(TL,th), b=pt(TS,th), f=Math.min(a.f,b.f);
    items.push({t:"line",x1:a.x,y1:a.y,x2:b.x,y2:b.y,stroke:`rgba(200,214,255,${0.16*(0.4+0.6*f)})`,w:0.7,z:f});
  }
  const k=scaleK(all,Math.min(W,H)*0.03);
  for(const c of all) items.push({t:"candle",p:c.p,z:c.p.f});
  items.sort((a,b)=>a.z-b.z);
  return {k,items,labels:[]};
}

function computeScene(){
  switch(ui.comp){
    case "motorway":  return buildMotorway();
    case "health":    return buildHealth();
    case "circuit":   return buildCircuit();
    case "coaster":   return buildCoaster();
    case "financial": return buildFinancial();
    case "cake":      return buildCake();
    default:          return buildDNA();
  }
}

function drawCandle(g,p,k){
  const f=p.f, col=colourFor(p.c,p.s), scl=p.scl||1;
  const w=(2.2+f*4.0)*(0.6+0.4*ui.size)*scl;
  g.save();
  g.globalAlpha=(0.22+f*0.78)*p.a;
  g.strokeStyle=col; g.fillStyle=col;
  g.lineWidth=0.8+f*1.0;
  if(p.ohlcY){
    const y=p.ohlcY;
    g.beginPath(); g.moveTo(p.x,y.h); g.lineTo(p.x,y.l); g.stroke();
    const top=Math.min(y.o,y.c), bot=Math.max(y.o,y.c);
    g.fillRect(p.x-w/2,top,w,Math.max(bot-top,1.1));
  } else {
    const c=p.c, mid=(c.high+c.low)/2, kk=k*scl, Y=v=>-(v-mid)*kk;
    g.translate(p.x,p.y);
    g.beginPath(); g.moveTo(0,Y(c.high)); g.lineTo(0,Y(c.low)); g.stroke();
    const top=Y(Math.max(c.open,c.close)), bot=Y(Math.min(c.open,c.close));
    g.fillRect(-w/2,top,w,Math.max(bot-top,1.1));
  }
  g.restore();
}

function drawScene(g,scene){
  const {k,items,labels}=scene;
  g.lineCap="round";
  for(const it of items){
    if(it.t==="line"){
      g.globalAlpha=ui.lineOpacity;
      g.strokeStyle=it.stroke; g.lineWidth=it.w;
      g.beginPath(); g.moveTo(it.x1,it.y1); g.lineTo(it.x2,it.y2); g.stroke();
    } else {
      drawCandle(g,it.p,k);
    }
  }
  if(labels){
    g.globalAlpha=1; g.textBaseline="middle";
    for(const L of labels){ g.font=L.font; g.fillStyle=L.fill; g.textAlign=L.align; g.fillText(L.text,L.x,L.y); }
  }
}

function render(){
  ctx.clearRect(0,0,W,H);
  drawScene(ctx,computeScene());
  ctx.globalAlpha=1;
}

function exportPNG(){
  const scale=2;
  const off=document.createElement("canvas");
  off.width=Math.round(W*scale); off.height=Math.round(H*scale);
  const g=off.getContext("2d");
  g.scale(scale,scale);
  drawScene(g,computeScene());
  off.toBlob(blob=>{
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");
    a.href=url; a.download="helix.png";
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(url),1000);
  },"image/png");
}

let last=performance.now();
function tick(now){
  const dt=Math.min((now-last)/1000,0.05); last=now;
  if(ui.playing){ phase+=dt*ui.speed*0.9; flow+=dt*ui.flow; }
  render();
  requestAnimationFrame(tick);
}

function bind(id,key,fmt,after){
  const el=document.getElementById("eng-"+id+uid);
  const out=document.getElementById("eng-v"+id.charAt(0).toUpperCase()+id.slice(1)+uid);
  const upd=()=>{ ui[key]=+el.value; if(out) out.textContent=fmt(ui[key]); if(after) after(); };
  el.addEventListener("input",upd); el.value=ui[key]; upd();
}
bind("speed","speed",v=>v.toFixed(2));
bind("flow","flow",v=>v.toFixed(2));
bind("twist","twist",v=>v.toFixed(1));
bind("amp","amp",v=>v.toFixed(2));
bind("size","size",v=>v.toFixed(2));
bind("scatter","scatter",v=>v.toFixed(2));
bind("lineOpacity","lineOpacity",v=>v.toFixed(2));
bind("voff","voff",v=>v|0);
bind("n","n",v=>v|0,()=>{ ui.n=ui.n|0; });

const modeEl=document.getElementById("eng-mode"+uid);
modeEl.querySelectorAll("button").forEach(b=>{
  b.addEventListener("click",()=>{
    modeEl.querySelectorAll("button").forEach(x=>x.classList.remove("on"));
    b.classList.add("on"); ui.mode=b.dataset.m;
  });
  b.classList.toggle("on", b.dataset.m===ui.mode);
});
document.getElementById("eng-regen"+uid).addEventListener("click",resetData);
const playBtn=document.getElementById("eng-play"+uid);
playBtn.addEventListener("click",()=>{ ui.playing=!ui.playing; playBtn.textContent=ui.playing?"Pause":"Play"; });
playBtn.textContent=ui.playing?"Pause":"Play";
document.getElementById("eng-export"+uid).addEventListener("click",exportPNG);
const compSel=document.getElementById("eng-comp"+uid);
compSel.addEventListener("change",()=>{ ui.comp=compSel.value; phase=0; flow=0; finLo=finHi=null; resetData(); });
compSel.value=ui.comp;

const panel=document.getElementById("eng-panel"+uid);
cv.addEventListener("dblclick",()=>{ panel.style.display="block"; });
panel.addEventListener("dblclick",()=>{ panel.style.display="none"; });

resize();
requestAnimationFrame(tick);
};

// Flush any instances that initialised before this script loaded
(window._engQ||[]).forEach(function(a){window.Engineering(a[0],a[1]);});
window._engQ=null;
